import {BaseSearchRequest} from "./baseSearchRequest";
import { OrderBy } from "ngx-odata-v4";
/**
 * Created by alex.y on 9/7/2017.
 */
export class CustomerSearchRequest extends BaseSearchRequest {
    public FillOrders: boolean;
    public OrderBy : {PropertyName: string , OrderBy: OrderBy}

public constructor(obj : Partial<CustomerSearchRequest>){
        super();
        Object.assign(this,obj);
    }

}


// WEBPACK FOOTER //
// ./app/objects/requests/customerSearchRequest.ts